import React, { useState } from "react";

import * as S from "./styles";
import useForm from "../../utils/useForm";
import { materialLead } from "../../core/materialLead";
import { landingPageRegistration } from "../../core/landingPageRegistration";
import { SUBSCRIPTION_KEY } from "../../core/storageKeys";

const formatWhatsapp = (value) => {
  const digits = value.replace(/\D/g, "").slice(0, 11);

  if (digits.length <= 2) {
    return digits.replace(/^(\d{0,2})/, "($1");
  }
  if (digits.length <= 6) {
    return digits.replace(/^(\d{2})(\d{0,4})/, "($1) $2");
  }
  if (digits.length <= 10) {
    return digits.replace(/^(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3");
  }
  return digits.replace(/^(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
};

const ModalLead = (props) => {
  const [{ values }, handleChange, handleSubmit] = useForm();
  const { toggleModal, isSimulatedInfoPage, onSuccess, hideClose, buttonLabel } =
    props;
  const [loading, setLoading] = useState(false);

  const handleWhatsappChange = (event) => {
    event.target.value = formatWhatsapp(event.target.value);
    handleChange(event);
  };

  const enviarContato = async () => {
    const payload = {
      ...values,
      whatsapp: (values.whatsapp || "").replace(/\D/g, ""),
    };

    localStorage.setItem(SUBSCRIPTION_KEY, JSON.stringify(payload));
    setLoading(true);

    await Promise.all([materialLead(payload), landingPageRegistration(payload)]);

    if (onSuccess) {
      onSuccess();
    }

    toggleModal();
  };

  return (
    <S.Container className="modal is-active">
      <S.Background
        className="modal-background"
        onClick={() => toggleModal()}
      />
      <S.Card className="modal-card">
        {!hideClose && (
          <S.Close aria-label="close" onClick={() => toggleModal()}>
            <S.CloseIcon icon="close" width={16} height={16} />
          </S.Close>
        )}
        <S.Header>
          <S.Asset />
          <S.Title>ACESSAR CONTEÚDO</S.Title>
          <S.Text>
              Preencha os campos abaixo para liberar seu acesso ao
              simulado Craques do ENEM:
          </S.Text>
        </S.Header>
        <S.Form onSubmit={handleSubmit(enviarContato)}>
          <S.FormInputWrapper>
            <S.Input
              required
              type="text"
              name="name"
              placeholder="Nome"
              onChange={handleChange}
            />
            <S.Input
              required
              type="email"
              name="email"
              placeholder="E-mail"
              onChange={handleChange}
            />
            <S.Input
              required
              type="tel"
              name="whatsapp"
              placeholder="WhatsApp"
              value={values.whatsapp || ""}
              onChange={handleWhatsappChange}
              pattern="\(\d{2}\) \d{4,5}-\d{4}"
              title="Digite no formato (99) 99999-9999 ou (99) 9999-9999"
            />
            <S.Button type="submit" disabled={loading} loading={loading}>
              {buttonLabel ||
                (isSimulatedInfoPage
                  ? "VER SIMULADO"
                  : "INSCREVA-SE GRATUITAMENTE")}
            </S.Button>
          </S.FormInputWrapper>
        </S.Form>
      </S.Card>
    </S.Container>
  );
};

export default ModalLead;
